// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Tente de novo utilizar uma data completa como esta: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupo',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valor',
  checkboxSet_requiredMessageDetail: () => 'Obrigatório',
  checkbox_requiredMessageDetail: () => 'Obrigatório',
  close: () => 'Fechar',
  collection_noData: () => 'Não existem dados para apresentação.',
  collection_selectAllRows: () => 'Selecionar Todas as Linhas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Selecionar linha ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Não ordenável',
  collection_sortEnabled: () => 'Ordenável',
  confirmation: () => 'Confirmação',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  dataVisualization_noData: () => 'Não existem dados para apresentação',
  dataVisualization_stateSelected: () => 'Selecionado',
  dataVisualization_stateUnselected: () => 'Não selecionado',
  error: () => 'Erro',
  expandableList_expandCollapseInstructionText: () =>
    'Utilize as teclas de seta para expandir e contrair',
  expandableList_groupCollapse: () => 'Contraído',
  expandableList_groupExpand: () => 'Expandido',
  filePicker_addFiles: () => 'Acrescentar Ficheiros',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Largar',
  filePicker_dropzoneSecondaryText: () => 'Selecionar um ficheiro ou largar um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecionar ou largar ficheiros aqui',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível carregar ficheiros do tipo: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Carregue um ficheiro de cada vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível carregar ficheiros do tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  formControl_clear: () => 'Limpar',
  formControl_day: () => 'Dia',
  formControl_helpAvailable: () => 'Auxílio disponível',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Atingiu o limite de ' +
    ((
      {
        one: '1 carácter',
        many: new Intl.NumberFormat('pt-PT').format(p['CHARACTER_LIMIT']) + ' de caracteres'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('pt-PT').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('pt-PT').format(p['CHARACTER_LIMIT']) + ' caracteres') +
    '.',
  formControl_loading: () => 'A Carregar',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Comprimento máximo ' + p['MAX_LENGTH'] + ' excedido.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres em falta.',
  formControl_month: () => 'Mês',
  formControl_readOnly: () => 'Só de leitura',
  formControl_requiredMessageDetail: () => 'Introduza um valor.',
  formControl_year: () => 'Ano',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Fim',
  gantt_labelLabel: () => 'Etiqueta',
  gantt_labelRow: () => 'Linha',
  gantt_labelStart: () => 'Início',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma secção correspondente encontrada.',
  indexer_keyboardInstructionText: () => 'Prima Enter para selecionar o valor.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha o toque para entrar no modo de gestos, em seguida, arraste para cima ou para baixo para ajustar o valor.',
  info: () => 'Informações',
  inputDateMask_date_cleared: () => 'Data limpa',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Vazia',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputNumber_converterParseError: () => 'Introduza um número.',
  inputNumber_decrease: () => 'Diminuir',
  inputNumber_increase: () => 'Aumentar',
  inputPassword_hidden: () => 'Senha Oculta',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_show: () => 'Mostrar Senha',
  list_suggestion: () => 'Sugestão',
  messageToast_allMessagesClosed: () => 'Todas as mensagens de alerta foram fechadas.',
  message_close: () => 'Fechar',
  message_confirmation: () => 'Êxito',
  message_error: () => 'Erro',
  message_info: () => 'Informações',
  message_navigationFromMessagesRegion: () =>
    'A entrar na região de mensagens. Prima F6 para navegar novamente para o elemento anteriormente focado.',
  message_navigationToMessagesRegion: () =>
    'A região das mensagens tem mensagens novas. Prima F6 para navegar para a mais recente região de mensagens.',
  message_warning: () => 'Aviso',
  noData_message: () => 'Não existem itens para apresentação',
  overflowItemLabel: () => 'Mais Separadores',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'A Decorrer',
  radio_helpForRadio: () => 'Auxílio do botão de rádio',
  radio_requiredMessageDetail: () => 'Selecione um valor.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Retroceder',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Prima a tecla de retrocesso ou a tecla Delete para retirar o valor selecionado.',
  selectMultiple_selectedValues: () => 'Valores selecionados',
  selectMultiple_showSelectedValues: () => 'Mostrar só valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  select_addToList: () => 'Acrescentar à lista',
  select_addToListAvailable: () => 'Acrescentar à lista disponível',
  select_moreSearchOptions: () => 'Mais opções de pesquisa',
  select_moreSearchOptionsAvailable: () => 'Mais opções de pesquisa disponíveis',
  select_noMatchesFound: () => 'Não foram encontradas correspondências.',
  select_oneMatchFound: () => 'Foi encontrada uma correspondência',
  select_requiredMessageDetail: () => 'Selecione um valor.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selector_selected: () => 'Caixa de seleção selecionada',
  selector_unselected: () => 'Caixa de seleção não selecionada',
  tabBarNavigationList_removeCueText: () => 'Retirável',
  timeComponent_tooltipZoomIn: () => 'Aproximar',
  timeComponent_tooltipZoomOut: () => 'Afastar',
  train_current: () => 'Atual',
  train_message_type: () => 'Tipo de Mensagem',
  train_not_visited: () => 'Não visitado',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Passo ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitado',
  userAssistance_learnMore: () => 'Mais informações',
  userAssistance_required: () => 'Obrigatório',
  viz_drillable: () => 'Passível de definir o nível de detalhe',
  warn: () => 'Aviso'
};
export default bundle;
